import { createSlice } from '@reduxjs/toolkit';

const currencySlice = createSlice({
  name: 'currency',
  initialState: {
    currency: 'eur',
    currencySymbol: '€',
  },
  reducers: {},
});

export default currencySlice.reducer;
